module.exports = __webpack_public_path__ + "img/z_arrow.5f3da61.png";